import React from "react";
import { AlertTriangle, RefreshCcw, Phone } from "lucide-react";
import { BRAND, telHref } from "../lib/site";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI ErrorBoundary caught:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="error-boundary"
        className="min-h-screen flex items-center justify-center bg-slate-50 p-6"
      >
        <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 shadow-xl p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-red-50 ring-4 ring-red-100 grid place-items-center mx-auto">
            <AlertTriangle className="text-red-600" size={28} />
          </div>
          <h1 className="mt-5 text-2xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>
            Kuch galat ho gaya
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            Hum maafi chahte hain. Thodi der baad page refresh kijiye ya hum se directly contact kijiye.
          </p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={this.reset}
              data-testid="error-retry-btn"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-blue-800 hover:bg-blue-900 text-white text-sm font-semibold shadow"
            >
              <RefreshCcw size={16} /> Refresh Page
            </button>
            <a
              href={telHref}
              data-testid="error-call-btn"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-orange-600 hover:bg-orange-700 text-white text-sm font-semibold shadow"
            >
              <Phone size={16} /> Call {BRAND.phone}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
